import { OfferKindEnum } from '../../../../../services/exports/Constants';

const OfferLabel: Record<OfferKindEnum, string> = {
  [OfferKindEnum.PercentageOffByMinSpendValue]: '{{percentageAmount}}% Rabatt ab {{minSpendValue}}',
  [OfferKindEnum.PercentageOffByProducts]: 'Spare {{percentageAmount}}% auf ausgewählte Artikel',
  [OfferKindEnum.AmountOffByProducts]: 'Spare {{amount}} auf ausgewählte Artikel',
  [OfferKindEnum.AmountOffByMinSpendValue]: 'Spare {{amount}} ab {{minSpendValue}}',
  [OfferKindEnum.Bogo]: '2 zum Preis von 1 – Nur heute',
  [OfferKindEnum.BogoHalfPrice]: '1 kaufen, das zweite zum halben Preis',
  [OfferKindEnum.FreeItemByProducts]: 'Heute: Sichere dir deinen Gratisartikel!',
  [OfferKindEnum.FreeItemByMinSpendValue]: 'Heute: Sichere dir deinen kostenlosen Artikel bei einem Bestellwert!',
};

export default OfferLabel;
